if(!customElements.get('box-option-selection')) {
  class BoxOptionSelection extends HTMLElement{
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form');
      this.swatchList = this.querySelector('.box-swatch-options');
      this.optionSelectionOpenerBtn = this.querySelector('.btn-swatch-list-opener');

      this.optionSelectionOpenerBtn.addEventListener('click', this.handleSwatchListOpener.bind(this));
      this.addEventListener('change', this.handleOptionSelection.bind(this));
    }

    handleOptionSelection(evt){
      this.swatchList.classList.toggle('hidden');
      this.optionSelectionOpenerBtn.querySelector('.label').innerText = evt.target.value;
      this.querySelector('.box-swatch-preview').style.backgroundImage = `url(${evt.target.nextSibling.querySelector('img').src})`;
    }

    handleSwatchListOpener(evt){
      this.swatchList.classList.toggle('hidden');
    }
  }

  customElements.define('box-option-selection', BoxOptionSelection);
}